export default __webpack_public_path__ + "static/media/Group_7472.c82db530.png";